import "./assets/css/style.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { About, Contact, Home, Patners, Products, Services } from "./pages";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/patners" element={<Patners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<Products />} />
          <Route path="/:slug" element={<Services />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
